<template>
  <div class="history-card-wrapper">
    <div class="video-item">
      <router-link :to="`/video/${video.videoId}`" target="_blank" class="cover-container">
        <el-image
            lazy
            fit="cover"
            :src="video.coverUrl"
            class="video-cover"
        />
        <div class="duration-badge">{{ video.duration }}</div>
        <div class="progress-bar-wrap">
          <div class="progress-inner" :style="{ width: setItemProgress(video) + '%' }"></div>
        </div>
      </router-link>

      <div class="info-container">
        <router-link :to="`/video/${video.videoId}`" target="_blank" class="title-link">
          <h3 class="video-title">{{ video.title }}</h3>
        </router-link>

        <div class="meta-data">
          <span class="device-tag">
            <i :class="video.horizontal ? 'el-icon-monitor' : 'el-icon-mobile-phone'" />
            {{ video.horizontal ? '横屏' : '竖屏' }}
          </span>

          <div class="stats">
            <span><i class="el-icon-video-play" /> {{ getVisited(video.view) }}</span>
            <span><i class="el-icon-chat-dot-square" /> {{ getVisited(video.comment) }}</span>
          </div>
        </div>

        <div class="user-line">
          <router-link :to="`/user/${video.user.userId}`" target="_blank" class="author-name">
            <i class="el-icon-user" /> {{ video.user.screenName }}
          </router-link>
          <span class="divider">•</span>
          <span class="watch-progress-text">已观看 {{ setItemProgress(video) }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleVisited } from 'assets/js/utils'

export default {
  name: 'HistoryVideoCard',
  props: {
    video: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getVisited(visited) {
      return handleVisited(visited)
    },
    setItemProgress(video) {
      if (!video.duration || !video.currentTime) return 0
      // 假设 duration 格式为 "05:20"，需要逻辑转换或后端直接给百分比
      // 这里暂时沿用你的逻辑计算
      const progress = Math.floor((video.currentTime / video.duration) * 100)
      return progress > 100 ? 100 : progress
    }
  }
}
</script>

<style scoped>
.history-card-wrapper {
  width: 100%;
}

.video-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

/* 封面区域 */
.cover-container {
  position: relative;
  width: 160px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  display: block;
}

.video-cover {
  width: 100%;
  height: 100%;
  transition: transform 0.3s;
}

.cover-container:hover .video-cover {
  transform: scale(1.05);
}

.duration-badge {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

/* 自定义进度条 */
.progress-bar-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
}

.progress-inner {
  height: 100%;
  background: #1890ff; /* 主题蓝 */
  transition: width 0.3s;
}

/* 信息区域 */
.info-container {
  flex: 1;
  min-width: 0; /* 修复 flex 下文本溢出问题 */
}

.title-link {
  text-decoration: none;
}

.video-title {
  font-size: 15px;
  font-weight: 600;
  color: #18191c;
  margin: 0 0 8px 0;
  line-height: 1.4;
  /* 多行截断 */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-title:hover {
  color: #1890ff;
}

.meta-data {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #9499a0;
  font-size: 12px;
  margin-bottom: 8px;
}

.device-tag {
  background: #f1f2f3;
  padding: 1px 6px;
  border-radius: 4px;
  color: #61666d;
}

.stats span {
  margin-right: 10px;
}

.user-line {
  font-size: 12px;
  color: #9499a0;
  display: flex;
  align-items: center;
}

.author-name {
  color: #61666d;
  text-decoration: none;
}

.author-name:hover {
  color: #1890ff;
}

.divider {
  margin: 0 8px;
}

.watch-progress-text {
  color: #ff6699; /* 醒目的粉色提示进度 */
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
  .cover-container {
    width: 130px;
    height: 75px;
  }
  .video-title {
    font-size: 13px;
    -webkit-line-clamp: 1; /* 手机端只显示一行 */
  }
  .meta-data {
    display: none; /* 手机端隐藏部分次要信息 */
  }
}
</style>
